import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useServiceContractsStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap(tokens.spacingVerticalM),
        marginTop: tokens.spacingVerticalL
    },
    agreeButton: {
        width: '190px',
        height: '40px',
        display: 'block'
    }
});

export default useServiceContractsStyles;
